/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import UserResponse from './UserResponse';

/**
* The SearchUsersResponse model module.
* @module model/SearchUsersResponse
* @version 2020-12-7
*/
export default class SearchUsersResponse {
    /**
    * Constructs a new <code>SearchUsersResponse</code>.
    * ユーザー検索レスポンス
    * @alias module:model/SearchUsersResponse
    * @class
    * @param users {Array.<module:model/UserResponse>} ユーザー
    * @param result {module:model/SearchUsersResponse.ResultEnum} 
    */

    constructor(users, result) {
        
        
        this['users'] = users;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchUsersResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchUsersResponse} obj Optional instance to populate.
    * @return {module:model/SearchUsersResponse} The populated <code>SearchUsersResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchUsersResponse();
                        
            
            if (data.hasOwnProperty('users')) {
                obj['users'] = ApiClient.convertToType(data['users'], [UserResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * ユーザー
    * @member {Array.<module:model/UserResponse>} users
    */
    'users' = undefined;
    /**
    * @member {module:model/SearchUsersResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
